import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ModalController, NavController, PopoverController} from "@ionic/angular";
import {MainService} from "../../../../services/MainService";
import {OrderService} from "../../../../services/OrderService";
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";
import {ActivatedRoute} from "@angular/router";
import {Address} from "../../../../../framework/model/core/address/address";
import {AppUser} from "../../../../../framework/model/core/appuser/appuser";
import {Order} from "../../../../../framework/model/core/order/order";
import {NewAddressPage} from "./pages/new-address/new-address.page";
import {Business} from "../../../../../framework/model/core/business/business";
import {BusinessService} from "../../../../services/BusinessService";
import {Events} from "../../../../../framework/providers/events";
import {AppSettings} from "../../../../conf/appSettings";
import {CartService} from "../../../../services/CartService";

@Component({
  selector: 'order-address',
  templateUrl: './order-address.component.html',
  styleUrls: ['./order-address.component.scss'],
})
export class OrderAddressComponent implements OnInit {

    order: Order;
    // address: Address;
    appuser: AppUser;

    addresses: Array<Address> = [];
    addressPrefix: string = 'addressPrefix'+ Math.floor(Math.random() * Math.floor(1000000));;
    choosedAddress: Address;

    business:Business;
    options: object = {};
    // formOptions: object = {};

    notOnRadius: boolean = false;

    subtitleFields = ['floor', 'apt', 'building']

    @Input()
    public companyId;

    @Input()
    public disableAdd = false;

    public filters: object;
    public cartData: object;
    public settings: object;

    // @ViewChild('slides', null) slides: IonSlides;

    constructor(public events: Events, public navCtrl: NavController, public mainService: MainService, public orderService: OrderService, public cartService:CartService,
                public modalController:ModalController, public businessService:BusinessService, public appsettings: AppSettings) {
        //
        // this.route.queryParams.subscribe(params => {
        //     this.order = params['order']
        // });

        this.appuser = this.orderService.getAppUser();
        this.order = this.orderService.getOrder();
        this.business = this.businessService.getBusiness();


        let settings = this.settings = this.appsettings.getSettings('orders');
        if(settings['address_fields'])
            this.subtitleFields = settings['address_display_subtitleFields'] || this.subtitleFields;


        // this.address = new Address({});

        this.events.subscribe('appuserChanged', (res)=>{
            this.appuser = this.orderService.getAppUser();
        }, this.addressPrefix);

        this.events.subscribe('agentCompanyChanged', (res)=>{
            this.events.publish(this.addressPrefix+'_updateModels');
        }, this.addressPrefix);
    }

    ngOnDestroy()
    {
        this.events.unsubscribe('appuserChanged', this.addressPrefix);
        this.events.unsubscribe('agentCompanyChanged', this.addressPrefix);

        // console.log(this.addressPrefix, 'DEST')
        // this.events.unsubscribe('agentCompanyChanged');
    }

    ngOnInit() {
        if(!this.companyId)
        {
            this.companyId = this.appuser.data.companyId;
        }

        this.filters = {'company':this.companyId, 'disableLoading':true};
        this.cartData = this.cartService.cartData;


        if(this.business.data.GlobalSettingsData.onlyStaffAddressEdit && !this.orderService.isStaffOrAgent())
        {
            this.disableAdd = true;
        }

        this.events.subscribe(this.addressPrefix + '_modelUpdated', (res) => {
            var me = this;
            setTimeout(function () {
                var adrs = me.order.data.address;

                if (me.addresses.length) {
                    for (var k in me.addresses) {
                        if (me.addresses[k].data.shippingData['active'] && !adrs['id']) {
                            adrs = me.addresses[k].data;
                            // return;
                        }
                    }
                }
                else
                    adrs = null;

                me.chooseAddress(new Address(adrs ? adrs : {}));
            }, 300)
        })
        // const mexicoCity = new google.maps.LatLng(19.432608, -99.133209.);
        // this.setFirstStep()

    }

    ngAfterViewInit() {
    }


    async newAddress() {
        let me = this;
        const modal = await this.modalController.create({
            component: NewAddressPage,
            componentProps: {
                'models':this.addresses,
                'callback':function(address) {
                    me.chooseAddress(address)
                }
            }
        });

        return await modal.present();
    }

    chooseAddress(address, force=false) {
        // if (!address.data.onRadius) {
        //     this.notOnRadius = true;
        //     return;
        // }
        if(this.disableAdd) return;

        this.notOnRadius = false;
        this.orderService.setAddress(address, force)
        this.choosedAddress = address;
    }

}
